import type { FC } from 'react';
import { Box } from '@interstate/components/Box';
import { Modal } from '@interstate/components/Modal';
import { Spinner } from '@interstate/components/Spinner';
import { Typography } from '@interstate/components/Typography';

export const FIRST_PENCIL_CREATING_MESSAGE = 'Building your first pencil scenarios';
export const FIRST_PENCIL_CREATING_OVERLAY_TEST_ID = 'first-pencil-creating-overlay';

export const FirstPencilCreatingOverlay: FC = () => (
    <Modal
        show
        id={FIRST_PENCIL_CREATING_OVERLAY_TEST_ID}
        customIdentifiers={{ title: { id: `${FIRST_PENCIL_CREATING_OVERLAY_TEST_ID}-title` } }}
        size="fullScreen"
        padding={false}
        data-testid={FIRST_PENCIL_CREATING_OVERLAY_TEST_ID}
        sx={{
            '.MuiDialog-paper': {
                margin: 0,
                width: '100%',
                height: '100%',
                maxWidth: 'none',
                maxHeight: 'none',
                borderRadius: 0,
                boxShadow: 'none',
                backgroundColor: 'base.color.gray.50'
            }
        }}
    >
        <Box
            role="status"
            aria-live="polite"
            aria-busy="true"
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1rem'
            }}
        >
            <Spinner />
            <Typography variant="body-md" tag="span" data-testid={`${FIRST_PENCIL_CREATING_OVERLAY_TEST_ID}-message`}>
                <span id={`ids-modal-title-${FIRST_PENCIL_CREATING_OVERLAY_TEST_ID}`}>{FIRST_PENCIL_CREATING_MESSAGE}</span>
            </Typography>
        </Box>
    </Modal>
);
